import React from "react";
import { projects } from "../../assets/data/Projects";
import SectionHeading from "../SectionHeading/SectionHeading";
import Showcase from "../Showcase/Showcase";

const Portfolio = () => {
    return (
        <section name='portfolio'>
            <SectionHeading heading='Portfolio' borderBottom={true} />
            {projects.map((project, index) => {
                return <Showcase key={index} {...project} />;
            })}
        </section>
    );
};

export default Portfolio;
